import React from "react";
import { useTranslation } from "react-i18next";
import { cn } from "../../../lib/utils";

export function DeadStockTag({ isDead }) {
  const { t } = useTranslation();

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-[11px] font-bold whitespace-nowrap border",
        isDead
          ? "bg-rose-50 text-rose-700 border-rose-200/40"
          : "bg-emerald-50 text-emerald-700 border-emerald-200/40"
      )}
    >
      <span
        className={cn(
          "h-1.5 w-1.5 rounded-full",
          isDead ? "bg-rose-600 animate-pulse" : "bg-emerald-600"
        )}
      />
      {isDead ? t("inventory.deadStock") : t("status.active")}
    </span>
  );
}
